<h1 mat-dialog-title>{{ data.title }}</h1>

<mat-dialog-content>
    @if (data.message) {
    <p class="mb-4">{{ data.message }}</p>
    }

    <div class="bg-gray-100 border border-gray-200 rounded-lg divide-y divide-gray-200">
        <div class="flex items-center justify-between px-4 py-2">
            <span class="font-medium">Account ID:</span>

            <div class="flex items-center gap-1">
                <span class="font-mono">{{ data.accountId }}</span>

                <button
                    mat-icon-button
                    class="size-8! p-1! -mr-2"
                    matTooltip="Account ID kopiëren"
                    (click)="copyToClipboard(data.accountId, 'Account ID')"
                >
                    <mat-icon class="text-base!">content_copy</mat-icon>
                </button>
            </div>
        </div>
        <div class="flex items-center justify-between px-4 py-2">
            <span class="font-medium">Tijdelijk wachtwoord:</span>

            <div class="flex items-center gap-1">
                <span class="font-mono">{{ data.temporaryPassword }}</span>

                <button
                    mat-icon-button
                    class="size-8! p-1! -mr-2"
                    matTooltip="Wachtwoord kopiëren"
                    (click)="copyToClipboard(data.temporaryPassword, 'Wachtwoord')"
                >
                    <mat-icon class="text-base!">content_copy</mat-icon>
                </button>
            </div>
        </div>
    </div>

    <p class="mt-3 px-4 text-sm text-gray-600 text-xs">
        Bewaar deze gegevens veilig. Deze gegevens worden niet opnieuw getoond.
    </p>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button mat-dialog-close cdkFocusInitial>Sluiten</button>
</mat-dialog-actions>